export default {
  screen: {
    id: 'rm_metal_phone_part_screen',
    defaultMessage: 'Screen',
  },
  camera: {
    id: 'rm_metal_phone_part_camera',
    defaultMessage: 'Camera module',
  },
  electronics: {
    id: 'rm_metal_phone_part_electronics',
    defaultMessage: 'Electronics',
  },
  battery: {
    id: 'rm_metal_phone_part_battery',
    defaultMessage: 'Battery',
  },
  casing: {
    id: 'rm_metal_phone_part_casing',
    defaultMessage: 'Casing & structure',
  },
} as const
